import { z } from 'zod';

import {
  DynamicFieldsItemDeprecatedSchema,
  GroupingLevelsCamelCaseEnum,
  UtmOptionsEnum,
  UtmOptionsResponseEnum,
} from './taxonomy.js';

export const UTMConfigSchema = z.object({
  id: z.string(),
  integrationId: z.string(),
  isAutomaticMappingEnabled: z.boolean(),
  hasChanges: z.boolean(),
  hasDuplicates: z.boolean(),
  hasSavedConfiguration: z.boolean(),
  activityId: z.string(),
  isPlatformBudgetingLevelEnabled: z.boolean(),
});

export const UTMConfigsResponseSchema = z.object({
  data: z.object({
    items: z.array(UTMConfigSchema),
  }),
});

export const getUTMConfigQuerySchema = z.object({
  activityId: z.string(),
});

export const getUTMTableQuerySchema = z.object({
  startRow: z.number().optional(),
  endRow: z.number().optional(),
  groupKeys: z.array(z.string()).optional(),
});

const UTMOptionItemWithDynamicFieldSchema = z.object({
  key: z.string().optional(),
  label: z.string(),
  isDynamicField: z.boolean().nullish(),
});

export const UTMOptionsItem = z.partialRecord(
  UtmOptionsResponseEnum,
  z.array(z.string()),
);

export const MappedUTMOptionsItemSchema = z.partialRecord(
  UtmOptionsResponseEnum,
  z.array(UTMOptionItemWithDynamicFieldSchema),
);

export const UTMOptionsResponseSchema = z.object({
  data: z.object({
    items: z.array(UTMOptionsItem),
  }),
});

export const UTMOptionsWithSearchResponseSchema = z.object({
  data: z.object({
    items: z.array(z.string()),
  }),
});

export const getUTMOptionsQuerySchema = z.object({
  integrationId: z.string(),
});

export const getUTMOptionsWithSearchQuerySchema =
  getUTMOptionsQuerySchema.extend({
    utmType: UtmOptionsEnum.optional(),
    value: z.string().optional(),
  });

export const hasPopulatesRulesResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        hasPopulatedRules: z.boolean(),
      }),
    ),
  }),
});

export const getHasPopulatesRulesQuerySchema = z.object({
  utmType: UtmOptionsEnum,
});

export const getDynamicFieldsResponseSchema = z.object({
  data: z.object({
    items: z.array(DynamicFieldsItemDeprecatedSchema),
  }),
});

export const MappedDynamicFieldsItemSchema = z.partialRecord(
  GroupingLevelsCamelCaseEnum,
  z.array(UTMOptionItemWithDynamicFieldSchema),
);

export type UTMConfigsResponseType = z.infer<typeof UTMConfigsResponseSchema>;
export type UTMOptionsResponseType = z.infer<typeof UTMOptionsResponseSchema>;
export type UTMOptionsWithSearchResponseType = z.infer<
  typeof UTMOptionsWithSearchResponseSchema
>;
export type UTMOptionItemWithDynamicFieldType = z.infer<
  typeof UTMOptionItemWithDynamicFieldSchema
>;
export type MappedDynamicFieldsItemType = z.infer<
  typeof MappedDynamicFieldsItemSchema
>;
export type MappedUTMOptionsItemType = z.infer<
  typeof MappedUTMOptionsItemSchema
>;
export type UTMConfigType = z.infer<typeof UTMConfigSchema>;

// To be Deprecated
export const UTMConfigDeprecatedSchema = z.object({
  campaignCollectionId: z.number(),
  hasChanges: z.boolean(),
  hasDuplicates: z.boolean(),
  hasSavedConfiguration: z.boolean(),
  id: z.string(),
  integrationId: z.string(),
  isAutomaticMappingEnabled: z.boolean(),
});

export const getUTMConfigQueryDeprecatedSchema = z.object({
  campaignCollectionId: z.string(),
});

export const UTMConfigsResponseDeprecatedSchema = z.object({
  data: z.object({
    items: z.array(UTMConfigDeprecatedSchema),
  }),
});

export type UTMConfigsResponseDeprecatedType = z.infer<
  typeof UTMConfigsResponseDeprecatedSchema
>;

export type UTMConfigDeprecatedType = z.infer<typeof UTMConfigDeprecatedSchema>;
